import { render, staticRenderFns } from "./devicetype.vue?vue&type=template&id=664bf488&scoped=true"
import script from "./devicetype.vue?vue&type=script&lang=js"
export * from "./devicetype.vue?vue&type=script&lang=js"
import style0 from "./devicetype.vue?vue&type=style&index=0&id=664bf488&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664bf488",
  null
  
)

export default component.exports